export default "__VITE_ASSET__94459616__"